import { Link } from 'react-router-dom'
import { TabBar, headerStyles as styles } from './PageHeader'
import { CautionIcon, openQueriesText, useOpenQueries } from '../lib/openQueries'

export interface PairTab {
  label: string
  to: string
}

/* handoff §6, "Navigation load across the whole product": a merged rail row
   keeps both screens and both titles, and the sibling is one tab away in the
   page header's tab bar (V4 underline tabs, under PageHeader). The current
   screen is a label, not a link, and no tab carries a count (a number on a
   view switch reads as a queue to clear). The one mark is the caution beside
   Queries while a picker's query is open (lib/openQueries.tsx): the count is
   in its tooltip, not on the tab. */
export function PairTabs({ label, tabs, current }: { label: string; tabs: PairTab[]; current: string }) {
  const open = useOpenQueries(tabs.some((t) => t.to === '/queries'))
  const mark = (t: PairTab) =>
    t.to === '/queries' && open > 0 ? (
      <CautionIcon title={openQueriesText(open)} className={styles.tabCaution} />
    ) : null
  return (
    <TabBar label={label}>
      {tabs.map((t) =>
        t.label === current ? (
          <span key={t.label} className={styles.tabOn} aria-current="page">
            {t.label}
            {mark(t)}
          </span>
        ) : (
          <Link key={t.label} className={styles.tab} to={t.to}>
            {t.label}
            {mark(t)}
          </Link>
        ),
      )}
    </TabBar>
  )
}

export const PEOPLE_TABS: PairTab[] = [
  { label: 'Personnel', to: '/personnel' },
  { label: 'Groups', to: '/groups' },
]

export const PAY_TABS: PairTab[] = [
  { label: 'Wages', to: '/wages' },
  { label: 'Timesheets', to: '/timesheets' },
  { label: 'Queries', to: '/queries' },
]

// The pair shares its date range, so switching screens keeps the period.
export const productTabs = (from: string, to: string): PairTab[] => [
  { label: 'Product activity', to: `/product-activity?from=${from}&to=${to}` },
  { label: 'Batches', to: `/batches?from=${from}&to=${to}` },
]

// Sites & jobs' views (handoff: Picking jobs · Structure · Map). They share
// one Site selector (?site=), so switching view keeps the Site.
export const sitesTabs = (siteId?: string): PairTab[] => {
  const q = siteId ? `?site=${siteId}` : ''
  return [
    { label: 'Picking jobs', to: `/picking-jobs${q}` },
    { label: 'Structure', to: `/sites-jobs${q}` },
    { label: 'Map', to: `/sites-map${q}` },
  ]
}
